import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

/**
 * `/work-items/new` — no longer a real form. Every entry point
 * picks a concrete type (`/new/feature`, `/new/standalone`,
 * `/new/bug`); this stub defaults to "feature" and forwards any
 * `?project=` query string.
 */

const searchSchema = z.object({ project: z.string().optional() });

export const Route = createFileRoute("/_app/work-items/new/")({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/work-items/new/$type",
      params: { type: "feature" },
      search: search.project ? { project: search.project } : {},
    });
  },
});
